import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { CacheProvider } from "@emotion/react";
import emotionCache from "./emotionCache";

console.log("index.jsx loaded"); // ADD THIS

const container = document.getElementById("root");
console.log("Container:", container); // ADD THIS

const root = createRoot(container);
console.log("Root created"); // ADD THIS

root.render(
  <CacheProvider value={emotionCache}>
    <BrowserRouter basename="/">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </CacheProvider>
);

console.log("Render called"); // ADD THIS